import useJwt from '@/auth/jwt/useJwt'

const ROLE_DASHBOARD_ROUTE_MAP = {
    superuser: 'dashboard-super-user',
    regionaldataofficer: 'dashboard-regional-data-officer',
    shippingofficer: 'dashboard-shipping-officer',
    dataclerk: 'dashboard-data-clerk',
    dataprocessingcoordinator: 'dashboard-data-processing-coordinator',
    externalusers: 'dashboard-external-users',
    storesofficer: 'dashboard-stores-officer',
    warehouseoperationmanager: 'dashboard-warehouse-operation-manager',
    dataprocessingmanager: 'dashboard-data-processing-manager',
}

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
    return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => {
    const userData = localStorage.getItem('userData')
    return userData ? JSON.parse(userData) : null
}

export const normalizeUserRole = userRole => `${userRole || ''}`
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')

export const getPrimaryUserRole = userData => {
    if (!userData) return null

    if (Array.isArray(userData.roles) && userData.roles.length > 0) {
        const primaryRole = userData.roles[0]

        if (typeof primaryRole === 'string') return primaryRole
        if (primaryRole && typeof primaryRole.title === 'string') return primaryRole.title
        if (primaryRole && typeof primaryRole.name === 'string') return primaryRole.name
    }

    return userData.role || null
}

export const getDashboardRouteForLoggedInUser = userRole => {
    const routeName = ROLE_DASHBOARD_ROUTE_MAP[normalizeUserRole(userRole)]

    if (routeName) return { name: routeName }

    return { name: 'dashboard-overview' }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
    const userData = getUserData()

    if (userData && userData.change) return { name: 'auth-reset-password-v1' }

    return getDashboardRouteForLoggedInUser(getPrimaryUserRole(userData) || userRole)
}
